export default __webpack_public_path__ + "static/media/linkedin.74f01651.svg";